import type { JobRunStatus } from '../types/jobs';

const ALL_STATUSES: JobRunStatus[] = [
  'pending',
  'running',
  'completed',
  'partial',
  'failed',
  'cancelled',
];

interface JobFilterBarProps {
  status: JobRunStatus | undefined;
  onStatusChange: (status: JobRunStatus | undefined) => void;
}

/**
 * Filter bar displayed above the jobs table.
 * Currently supports status filtering only.
 */
export function JobFilterBar({ status, onStatusChange }: JobFilterBarProps) {
  return (
    <div className="job-filter-bar" role="toolbar" aria-label="Filter job runs">
      <button
        type="button"
        className={`job-filter-bar__btn${!status ? ' job-filter-bar__btn--active' : ''}`}
        onClick={() => onStatusChange(undefined)}
        aria-pressed={!status}
      >
        All
      </button>
      {ALL_STATUSES.map((s) => (
        <button
          key={s}
          type="button"
          className={`job-filter-bar__btn job-filter-bar__btn--${s}${status === s ? ' job-filter-bar__btn--active' : ''}`}
          onClick={() => onStatusChange(status === s ? undefined : s)}
          aria-pressed={status === s}
        >
          {s.charAt(0).toUpperCase() + s.slice(1)}
        </button>
      ))}
    </div>
  );
}
